module.exports = __webpack_public_path__ + "img/note.dad1d3f8.png";